import { render, staticRenderFns } from "./Perdiem.vue?vue&type=template&id=f9ef6f2c&"
import script from "./Perdiem.vue?vue&type=script&lang=ts&"
export * from "./Perdiem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports